import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import clsx from "clsx";
import MessagingBoxBodyItem from "./MessagingBoxBodyItem.jsx";
import { useChat } from "../../../../Providers/Data/ChatProvider.jsx";
import LoadingDots from "../../../../SharedComponents/LoadingDots.jsx";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column-reverse",
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    alignItems: "center",
    padding: 10,
  },
  msgsList: {
    display: "flex",
    flexDirection: "column-reverse",
    width: "100%",
    maxWidth: 600,
  },
  load: {
    marginTop: 10,
  },
  incoming: {
    alignSelf: "start",
  },
}));

/** */
const MessagingBoxBody = () => {
  const classes = useStyles();
  const { messages, loaderAiAnswer } = useChat();

  return (
    <Box className={classes.root}>
      {loaderAiAnswer && <LoadingDots size={8} color="#9e9e9e" className={clsx(classes.load, classes.incoming)} />}
      <Box className={classes.msgsList}>
        {messages.map((msg) => (
          <MessagingBoxBodyItem key={msg.id} data={msg} />
        ))}
      </Box>
    </Box>
  );
};

export default MessagingBoxBody;
